import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-my-product-codes-header',
  templateUrl: './lp-my-product-codes-header.component.html',
  styleUrls: ['./lp-my-product-codes-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpMyProductCodesHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
}
